/**
 * 按 1920 设计稿对整页做等比缩放。
 * 宽屏 / 浏览器缩放导致可视宽度变化时：版心仍按 1920 排版，再整体放大或缩小，
 * 避免图片随宽度变大而文字被 clamp 锁死，出现「字相对变小」的比例失调。
 * 小于 1024 的窄屏不缩放，继续走手机 / 平板响应式。
 *
 * zoom 加在 #app 上，不加在 html 上。Chrome 在浏览器缩放超过约 110% 时，
 * 根节点上的 zoom 会把 position:fixed 的顶栏和下拉裁出视口。
 */
const DESIGN_WIDTH = 1920
const ENABLE_MIN_WIDTH = 1024

function getApp() {
  return document.getElementById('app')
}

function clearScale() {
  const html = document.documentElement
  const app = getApp()
  html.classList.remove('page-scaled')
  html.style.removeProperty('zoom')
  html.style.removeProperty('--page-scale')
  html.style.removeProperty('--design-width')
  html.style.removeProperty('--layout-vh')
  html.style.width = ''
  html.style.minWidth = ''
  html.style.overflowX = ''
  document.body.style.width = ''
  document.body.style.minWidth = ''
  document.body.style.overflowX = ''
  document.body.style.zoom = ''
  if (!app) return
  app.style.width = ''
  app.style.minWidth = ''
  app.style.zoom = ''
  app.style.transform = ''
  app.style.transformOrigin = ''
}

function applyPageScale() {
  const html = document.documentElement
  const app = getApp()
  const width = window.innerWidth

  if (!app || width < ENABLE_MIN_WIDTH) {
    clearScale()
    return
  }

  const scale = width / DESIGN_WIDTH

  html.classList.add('page-scaled')
  html.style.removeProperty('zoom')
  html.style.width = ''
  html.style.minWidth = ''
  html.style.setProperty('--page-scale', String(scale))
  html.style.setProperty('--design-width', `${DESIGN_WIDTH}px`)
  html.style.setProperty('--layout-vh', `${Math.round(window.innerHeight / scale)}px`)
  document.body.style.width = ''
  document.body.style.minWidth = ''
  document.body.style.zoom = ''
  document.body.style.overflowX = 'hidden'
  app.style.width = `${DESIGN_WIDTH}px`
  app.style.minWidth = `${DESIGN_WIDTH}px`
  app.style.zoom = String(scale)
  app.style.transform = ''
  app.style.transformOrigin = ''
}

export function initPageScale() {
  applyPageScale()

  let timer = 0
  const onResize = () => {
    clearTimeout(timer)
    timer = window.setTimeout(applyPageScale, 16)
  }

  window.addEventListener('resize', onResize)
  window.addEventListener('orientationchange', onResize)
  window.visualViewport?.addEventListener('resize', onResize)
}
